import Vuex from "vuex";
import {auth} from "./auth.module";
import Vue from "vue";
import moment from "moment";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    filter: {
      period: "TODAY",
      group: "ALL",
      from: moment().format().slice(0,10) + 'T00:00:01',
      until: moment().format().slice(0,10) + 'T23:59:59',
      trip_day: moment().format().slice(0,10),
      update: moment().format()
    },
    heatmap: {
      eventType: "HARSH_ACCELERATION"
    }
  },
  modules: {
    auth
  }
});
